export default __webpack_public_path__ + "static/media/wood_charcoal.bdda2b72.jpg";